import React, { useState } from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    location: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Contact Form Submitted:', formData);
    alert('Thank you for your enquiry. We will get back to you shortly.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      location: '',
      message: ''
    });
  };
  return <main data-id="element-233">
      {/* Hero Banner */}
      <section className="bg-slate-900 py-20 text-center px-4" data-id="element-234">
        <div className="container mx-auto max-w-3xl" data-id="element-235">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-236">
            Contact Us
          </h1>
          <p className="text-xl text-slate-300" data-id="element-237">
            Get in touch with our team for enquiries, support, or to discuss
            your logistics needs.
          </p>
        </div>
      </section>

      <section className="py-20 bg-slate-50" data-id="element-238">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-239">
          <div className="flex flex-col lg:flex-row gap-12" data-id="element-240">
            {/* Contact Form */}
            <div className="lg:w-2/3 bg-white rounded-2xl shadow-sm border border-slate-200 p-8" data-id="element-241">
              <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-242">
                Send us a message
              </h2>
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-243">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-244">
                  <div data-id="element-245">
                    <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-246">
                      Name
                    </label>
                    <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-primary focus:border-primary outline-none transition-colors" placeholder="Your full name" data-id="element-247" />
                  </div>
                  <div data-id="element-248">
                    <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-249">
                      Email
                    </label>
                    <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-primary focus:border-primary outline-none transition-colors" placeholder="your@email.com" data-id="element-250" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-251">
                  <div data-id="element-252">
                    <label htmlFor="phone" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-253">
                      Phone
                    </label>
                    <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-primary focus:border-primary outline-none transition-colors" placeholder="Your phone number" data-id="element-254" />
                  </div>
                  <div data-id="element-255">
                    <label htmlFor="service" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-256">
                      Service Required
                    </label>
                    <select id="service" name="service" required value={formData.service} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-primary focus:border-primary outline-none transition-colors bg-white" data-id="element-257">
                      <option value="" data-id="element-258">Select a service</option>
                      <option value="emergency" data-id="element-259">
                        Emergency Parcel Delivery
                      </option>
                      <option value="contract" data-id="element-260">Contract Driver Supply</option>
                      <option value="furniture" data-id="element-261">
                        Furniture Delivery & Assembly
                      </option>
                      <option value="office-relocation" data-id="element-262">
                        Office Relocation
                      </option>
                      <option value="house-relocation" data-id="element-263">House Relocation</option>
                      <option value="other" data-id="element-264">Other</option>
                    </select>
                  </div>
                </div>

                <div data-id="element-265">
                  <label htmlFor="location" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-266">
                    Delivery Location / Area
                  </label>
                  <input type="text" id="location" name="location" required value={formData.location} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-primary focus:border-primary outline-none transition-colors" placeholder="e.g. London to Manchester" data-id="element-267" />
                </div>

                <div data-id="element-268">
                  <label htmlFor="message" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-269">
                    Message
                  </label>
                  <textarea id="message" name="message" required rows={5} value={formData.message} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-primary focus:border-primary outline-none transition-colors resize-none" placeholder="How can we help you?" data-id="element-270"></textarea>
                </div>

                <Button type="submit" size="lg" className="w-full md:w-auto" data-id="element-271">
                  Submit Enquiry
                </Button>
              </form>
            </div>

            {/* Contact Info */}
            <div className="lg:w-1/3 space-y-8" data-id="element-272">
              <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8" data-id="element-273">
                <h3 className="text-xl font-bold text-slate-900 mb-6" data-id="element-274">
                  Contact Information
                </h3>

                <div className="space-y-6" data-id="element-275">
                  <div className="flex items-start" data-id="element-276">
                    <PhoneIcon className="h-6 w-6 text-primary mr-4 shrink-0" data-id="element-277" />
                    <div data-id="element-278">
                      <p className="font-medium text-slate-900" data-id="element-279">Phone</p>
                      <p className="text-slate-600" data-id="element-280">0800 123 4567</p>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-281">
                    <MailIcon className="h-6 w-6 text-primary mr-4 shrink-0" data-id="element-282" />
                    <div data-id="element-283">
                      <p className="font-medium text-slate-900" data-id="element-284">Email</p>
                      <p className="text-slate-600" data-id="element-285">info@universalglobal.com</p>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-286">
                    <ClockIcon className="h-6 w-6 text-primary mr-4 shrink-0" data-id="element-287" />
                    <div data-id="element-288">
                      <p className="font-medium text-slate-900" data-id="element-289">
                        Business Hours
                      </p>
                      <p className="text-slate-600" data-id="element-290">24/7 Emergency Support</p>
                      <p className="text-slate-600 text-sm mt-1" data-id="element-291">
                        Office: Mon-Fri, 9am - 5pm
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-292">
                    <MapPinIcon className="h-6 w-6 text-primary mr-4 shrink-0" data-id="element-293" />
                    <div data-id="element-294">
                      <p className="font-medium text-slate-900" data-id="element-295">Headquarters</p>
                      <p className="text-slate-600" data-id="element-296">
                        123 Logistics Way
                        <br data-id="element-297" />
                        London, UK
                        <br data-id="element-298" />
                        EC1A 1BB
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="bg-slate-200 rounded-2xl h-64 flex items-center justify-center border border-slate-300 overflow-hidden relative" data-id="element-299">
                <div className="absolute inset-0 opacity-10" style={{
                backgroundImage: 'radial-gradient(circle at 2px 2px, #000 1px, transparent 0)',
                backgroundSize: '16px 16px'
              }} data-id="element-300"></div>
                <div className="text-center relative z-10" data-id="element-301">
                  <MapPinIcon className="h-10 w-10 text-slate-400 mx-auto mb-2" data-id="element-302" />
                  <p className="text-slate-500 font-medium" data-id="element-303">
                    Interactive Map Placeholder
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>;
}